import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { EnviarTokenFirmaElectronicaComponent } from '../tramitante/procesar-tramite/enviar-token-firma-electronica/enviar-token-firma-electronica.component';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { AlertIcon, AlertService, LoadingPanelService, LocalService, UserInfoResponse, VisorComponent } from 'lib-base';
import { FirmaElectronicaSolicitudService } from '../../services/firmaElectronicaSolicitud.service';
import { TokenEnviadoComponent } from '../tramitante/procesar-tramite/token-enviado/token-enviado.component';
import { EscribaTokenEnviadoComponent } from '../tramitante/procesar-tramite/escriba-token-enviado/escriba-token-enviado.component';
import { WebContribuyenteService } from '../../services/webContribuyenteService.service';
import { Router } from '@angular/router';
import { FirmaElectronicaTokenService } from '../../services/firmaElectronicaToken.service';
import { PortalAuthService } from '../../services/portalAuth.service';

@Component({
  selector: 'app-renovar-firma-electronica',
  standalone: true,
  imports: [TranslateModule, ButtonModule, TooltipModule, VisorComponent,
    EnviarTokenFirmaElectronicaComponent, TokenEnviadoComponent, EscribaTokenEnviadoComponent
  ],
  template: `
  <div class="p-grid p-justify-center p-align-start wrapper-content flex-column mt-4 mb-5">
    <div class="col-12 px-0">
      <div class="app-card">
        <h1 class="card-header title-blue font-roboto-condensed  font-23 font-normal">{{'components.app-pub-topbar.firma-electronica-renovacion-long' | translate}}</h1>
        <div class="card-body">
          <p>{{'msg.firmaElectronica-renovar-msg' | translate}}</p>
          <div [pTooltip]="'msg.esteUsuarioNoTieneFirmaElectronica' | translate" tooltipPosition="top" [tooltipDisabled]="!btnDisabled">
            <button pButton [label]="'msg.enviarCodigoVerificacion' | translate"
                    (click)="onRenovarFirmaElectronicaClick()"
                    [disabled]="btnDisabled"
                    class="bg-button-outline-blue-light  border-outline-blue-light text-blue-general font-normal	w-full"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-enviar-token-firma-electronica (onOptionSelected)="onEnviarTokenFirmaElectronica($event)"></app-enviar-token-firma-electronica>
  <app-token-enviado (onContinuar)="onContinuar($event)"></app-token-enviado>
  <app-escriba-token-enviado 
    (onReenviarToken)="onReenviarToken($event)" 
    (onSubmitToken)="onSubmitToken($event)"
    [btnSubmitLabel]="escribaTokenEnviadoBtnSubmitLabel"></app-escriba-token-enviado>
    <app-visor></app-visor>
  `
})
export class RenovarFirmaElectronicaComponent implements OnInit, AfterViewInit, OnDestroy {

  escribaTokenEnviadoBtnSubmitLabel: string = "";
  btnDisabled: boolean = false;
  trans: any = {};

  @ViewChild(EnviarTokenFirmaElectronicaComponent) private _enviarTokenFirmaElectronica !: EnviarTokenFirmaElectronicaComponent;
  @ViewChild(TokenEnviadoComponent) private _tokenEnviado !: TokenEnviadoComponent;
  @ViewChild(EscribaTokenEnviadoComponent) private _escribaTokenEnviado !: EscribaTokenEnviadoComponent;

  @ViewChild(VisorComponent) visorDialog !: VisorComponent;
  private _visorButton1Subscription !: Subscription;
  private _visorButton2Subscription !: Subscription;

  constructor(private _t: TranslateService, private _lps: LoadingPanelService, private _fes: FirmaElectronicaSolicitudService,
    private _wc: WebContribuyenteService, private _router: Router,  private _fet: FirmaElectronicaTokenService,
    private alertService: AlertService, private _pa: PortalAuthService, private _ls: LocalService
  ) { }

  ngOnInit(): void {
    this.translate().then(() => {
      this.escribaTokenEnviadoBtnSubmitLabel = this.trans.firmar;
    });
    this.usuarioTieneFirmaElectronicaActiva();
  }

  ngAfterViewInit(): void {
    this._visorButton1Subscription = this.visorDialog.button1Source$.subscribe(obj => {
      this.renovarFirmaElectronica();
    });
    this._visorButton2Subscription = this.visorDialog.button2Source$.subscribe(obj => {
      this._router.navigate(['/public/consulta']);
    });
  }

  ngOnDestroy(): void {
    if(this._visorButton1Subscription){
      this._visorButton1Subscription.unsubscribe();
    }
    if(this._visorButton2Subscription){
      this._visorButton2Subscription.unsubscribe();
    }
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      firmar: this._t.get('components.app-escriba-token-enviado.firmar'),
      aceptar: this._t.get('form.button.aceptar'),
      visorDialogTitle: this._t.get('components.app-activar-usuario.visorDialog-title'),
      cancelar: this._t.get('form.button.cancelar'),
      firmaElectronicaRenovadaTitle: this._t.get('msg.firmaElectronicaRenovada-title'),
      firmaElectronicaRenovadaHtml: this._t.get('components.app-activar-usuario.registrar-solicitud-html'),
    }));
  }

  onRenovarFirmaElectronicaClick() {
    this._enviarTokenFirmaElectronica.showDialog();
  }

  //#region EnviarTokenFirmaElectronicaComponent
  onEnviarTokenFirmaElectronica($event: 'correo' | 'sms') {
    this._enviarTokenFirmaElectronica.hideDialog();
    this._lps.show();
    this._fes.renovarFirmaElectronica($event).subscribe({
      next: (response: boolean) => {
        this._tokenEnviado.showDialog();
      }, error: (error) => {
        this._lps.hide();
      }
      , complete: () => {
        this._lps.hide();
      }
    });
  }
  //#endregion

  //#region TokenEnviadoComponent
  onContinuar($event: void) {
    this._tokenEnviado.hideDialog();
    this._escribaTokenEnviado.showDialog();
  }
  //#endregion

  //#region EscribaTokenEnviadoComponent
  onReenviarToken($event: void) {
    this._escribaTokenEnviado.hideDialog();
    this._enviarTokenFirmaElectronica.showDialog();
  }

  onSubmitToken($event: void) {
    this._lps.show();
    this.documentoSolicitudFirmaElectronica();
  }

  private documentoSolicitudFirmaElectronica() {
    this._wc.documentoSolicitudFirmaElectronica().subscribe({
      next: (response: Blob) => {
        this._lps.hide();
        if (response.size > 0) {
          this.visorDialog.title = this.trans.visorDialogTitle;
          this.visorDialog.button1Label = this.trans.aceptar;
          this.visorDialog.button2Label = this.trans.cancelar;
          this.visorDialog.showDialog(response);
        }
      }
    });
  }

  private renovarFirmaElectronica(){
    this._lps.show(true);
    const token = this._escribaTokenEnviado.form.get('token')?.value;
    this._wc.renovarFirmaElectronica(token).subscribe({
      next: (response: boolean) => {
        this._lps.hide();
        this.getUserInfo();    
      },
      error: (error) => {
        this._lps.hide();
        this._escribaTokenEnviado.hideDialog();
      }
    });
  }

  getUserInfo() {
    this._pa.getUserInfo().subscribe({
      next: (response: UserInfoResponse) => {
        this._ls.saveUser(response);
        this.alertService.show({
          icon: AlertIcon.SUCCESS,
          title: this.trans.firmaElectronicaRenovadaTitle,
          text: this.trans.firmaElectronicaRenovadaHtml,
          showAccept: true,
          textAccept: this.trans.aceptar,
        }).subscribe((event)=>{
          this._router.navigate(['/public/consulta']);
        });
      }
    });
  }
  //#endregion

  //#region FirmaElectronicaTokenService
  usuarioTieneFirmaElectronicaActiva() {
    this._lps.show(true);
    this._fet.usuarioTieneFirmaElectronicaActiva().subscribe({
      next: (response: boolean) => {
        this.btnDisabled = !response;
      }, complete: () => {
        this._lps.hide();
      }
    });
  }
  //#endregion
}
